import React, { useState } from 'react';
import { styled, Switch } from '@mui/material';
import './toggleStyle.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

function AnimatedToggleButton(props) {
  const [checked, setChecked] = useState(false);
  const { routeName, routeChange } = props;
  const handleToggle = () => {
    setChecked((prev) => !prev);
  };

  return (
    <div>
      <div class="container">
        <ul onClick={routeChange}>
          <li>
            <a>
              <i class="fa-solid fa-route"> {routeName}</i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default AnimatedToggleButton;
